import type { HeroProps } from '@/components/lemonadeGoesGlobal/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/lemonade_goes_global/de/og.png';
import logo from '@/static/assets/lemonade_goes_global/reddish/logo.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LemonadeGoesGlobal/lemonadeGoesGlobal__de-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
  logo: StaticImageData;
}

export const config: Config = {
  layout: { ...sharedConfig['de-DE'].layout, showAskUsAnything: true },
  seo: {
    title: 'Wo ist Lemonade in den USA und Europa verfügbar? | Lemonade',
    metaTitle: 'Wo ist Lemonade in den USA und Europa verfügbar? | Lemonade',
    description:
      'Lemonade ist auf dem Weg Versicherungen in den USA sowie in Europa anzubieten, die von Technologie und sozialem Engagement angetrieben sind ✨ Hier kannst du sehen wo Lemonade verfügbar ist, oder gib einfach deine E-Mail ein und wir werden dich benachrichtigen! GoLemonade',
    ogImage: og.src,
  },
  hero: {
    title: 'Erfahre es als Erste*r!',
    subtitle: `Wir sind dabei, in den gesamten <a href="https://www.lemonade.com/blog/lemonade-expansion-united-states/">USA</a> und Europa erhältlich zu sein. Hinterlass uns deine E-Mail\nund wir werden dich informieren, sobald wir auf dem Weg zu dir sind.`,
  },

  logo,
  MDXContent: content as DocumentTypes,
};
